import { SxProps, Theme } from '@mui/system';

export const listStyles: SxProps<Theme> = {
  overflow: 'auto',
  height: 'calc(100vh - 400px)',
  border: '1px solid',
};
